import { REGULAR_BUTTON_TYPE } from "./button-consts";

export default {
  buttonType: REGULAR_BUTTON_TYPE
};
